import fetch from '@/utils/fetch';

// zym.机构列表
export function listOrganization(params){     
  return fetch({
     //  url:'Rule/Rule/getOrganizationAndPostTree',
      url:'eavar/organization/listOrganization',
      method:"post",
      data:params

  })
}

// 创建、修改机构信息
export function menuCreate(params){     
     return fetch({
        //  url:'Rule/Rule/addOrUdateOrganization',
         url:'eavar/organization/addOrUpdateOrganization',
         method:"post",
         data:params
     })
}

// 删除机构、机构角色信息
export function delDot(params){     
  return fetch({
      // url:'Rule/Rule/delOrganizationAndPost',
      url:'eavar/organization/deleteOrganization',
      method:"post",
      data:params
  })
}

export function getMenu(params){
     
     return fetch({
        //  url:'Rule/Rule/getOrganizationAndPostTree',
         url:'eavar/organization/tree',
         method:"post",
         data:params

     })

}

// zym.初始化流程（新方法）
export function setWorks(params){     
  return fetch({
      url:'eavar/organization/setWorks',
      method:"post",
      data:params
  })
}

// zym.初始化申报资料（新方法）
export function setMaterials(params){     
  return fetch({
      url:'eavar/organization/setMaterials',
      method:"post",
      data:params
  })
}

// zym.初始化申报资料（连续电子）
export function setMaterialsLxdz(params){     
  return fetch({
      url:'eavar/organization/setMaterialsLxdz',
      method:"post",
      data:params
  })
}


// zym.保存书号系统Id（新方法）
export function saveClaimId(params){     
  return fetch({
      url:'eavar/organization/saveClaimId',
      method:"post",
      data:params
  })
}


// WEBPACK FOOTER //
// ./src/api/pgMent/sectMent.js